import { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RecommendedItem from '../../common/RecommendedItem/RecommendedItem';
import { MoviesQueryModel, RowConfig } from '../../types';
import styles from './RecommendedSlider.module.scss';

type Props = {
  name: string;
  data: MoviesQueryModel['row_0']['data'];
  queryName: string;
  config?: RowConfig;
  type: 'movies' | 'scenes';
  big?: boolean
  id?: string|number
  rawType?: string
};

const RecommendedSlider: FC<Props> = ({ name, data, config, id, queryName, type, big = false, rawType }) => {
  const { t } = useTranslation();
  const url = queryName;

  return (
    <div className={`mt-4 hpc-row ${styles.hpc__row}`}>
      <div className={`hpc-background ${styles.hpc__background}`}></div>
      <div className="flex flex-wrap justify-between content-center items-center mb-3 px-2">
        <h2 className={`text-mainRed font-semibold work-sans-font text-lg md:text-2xl ${styles.hpc__row__title} hover:opacity-75 pr-6`}>{name}</h2>

        <Link
          to={url + '?page=1'}
          className="text-mainRed block border border-2 border-mainRed px-3 py-1 text-sm font-semibold hover:bg-mainRed hover:text-white duration-100 opacity-75 rounded-lg"
        >
          {`${t('view all')} >`}
        </Link>
      </div>
      {data?.length ? (
        <div className="w-full recomended-slider">
          <RecommendedItem big={big} type={type} id={id} config={config} data={data} rawType={rawType}/>
        </div>
      ) : null}
    </div>
  );
};
export default memo(RecommendedSlider);
